import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translation using http -> see /public/locales
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    supportedLngs: [
      'en', 'en-GB', 'en-AU', 'en-NZ', 'da', 'da-DK', 'es', 'fr', 'de', 
      'zh', 'zh-CN', 'ja', 'pt', 'ru', 'ar', 'ko', 'it', 'tr', 'vi', 
      'pl', 'id', 'hi', 'bn', 'te', 'mr', 'ta', 'ur', 'gu', 'kn', 'ml', 'nl', 'pa', 'th'
    ],
    nonExplicitSupportedLngs: true,
    debug: import.meta.env.DEV,

    // Always read from localStorage first, ignore browser/navigator language
    // so user's manual language choice persists across Google/Apple login redirects
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'],
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    }
  });

export default i18n;
